<template>
  <v-dialog v-model="dialog" width="600">
    <v-card>
      <gg-toolbar @close="close">
        Revoke User Privileges
      </gg-toolbar>
      <v-card-text v-if="user && database">
        <p class="mb-0">
          Are you sure you wish to revoke privileges for “{{ user }}” from the database “{{ database }}”?
        </p>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <gg-btn secondary @click="close">Cancel</gg-btn>
        <gg-btn
          :loading="loading"
          @click="revoke"
        >
          Revoke
        </gg-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'RevokeUserModal',
  props: {
    user: {
      type: String,
      required: true,
    },
    database: {
      type: String,
      required: true,
    },
    opened: {
      type: Boolean,
      required: true,
    },
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    dialog: {
      get () {
        return this.opened
      },
      set () {
        this.close()
      }
    },
  },
  methods: {
    ...mapActions({
      revokeMysqlUserAccess: 'mysql/revokeMysqlUserAccess',
      reportSuccess: 'reportSuccess',
      reportError: 'reportError'
    }),
    close () {
      this.$emit('close')
    },
    async revoke () {
      this.loading = true
      try {
        await this.revokeMysqlUserAccess({
          user: this.user,
          database: this.database,
          _username: this.$route.query.user,
        })
        this.loading = false
        this.reportSuccess(`You have revoked “${this.user}” access to the database “${this.database}”.`)
        this.$emit('action-completed')
        this.close()
      } catch (e) {
        this.reportError(e)
      }
      this.loading = false
    }
  }
}
</script>
